import { CardPaymentRedirectRequest } from '@dgx-pr-spa/shared/util';
import { Address } from '@dgx-pr-spa/shared/util';
import { Contact } from '@dgx-pr-spa/shared/util';
import { CurrentPlan } from '@dgx-pr-spa/shared/util';
export class CardPaymentRedirectHelper {
  constructor(
    public currentPlan?: CurrentPlan,
    public replacementCost?: number,
    public contactDetails?: Contact,
    public deliveryAddress?: Address
  ) {}

  get requestBody(): CardPaymentRedirectRequest {
    const tel =
      this.contactDetails.mobile_tel ||
      this.contactDetails.home_tel ||
      this.contactDetails.work_tel ||
      '';

    return {
      requestSource: 'BVUK',
      channelCode: '0035',
      channelGroupCode: '0005',
      clientCode: this.currentPlan.client_code,
      clientGroupCode: this.currentPlan.client_group_code,
      companyCode: this.currentPlan.company_code,
      schemeCode: this.currentPlan.scheme_code,
      referenceNumber: this.currentPlan.reference_number,
      amount: this.replacementCost,
      currency: 'GBP',
      description: 'Product Replacement',
      name: `${this.contactDetails.forename} ${this.contactDetails.surname}`,
      mobTel: tel,
      email: this.contactDetails.contact_email || '',
      address: {
        addressLine1: this.deliveryAddress.address_line_1 || '',
        addressLine2: this.deliveryAddress.address_line_2 || '',
        addressLine3: this.deliveryAddress.address_line_3 || '',
        addressLine4: this.deliveryAddress.address_line_4 || '',
        countryCode: 'GBR',
        postalCode: this.deliveryAddress.postal_code,
      },
      billingAddress: {
        addressLine1: this.deliveryAddress.address_line_1 || '',
        addressLine2: this.deliveryAddress.address_line_2 || '',
        addressLine3: this.deliveryAddress.address_line_3 || '',
        addressLine4: this.deliveryAddress.address_line_4 || '',
        countryCode: 'GBR',
        postalCode: this.deliveryAddress.postal_code,
      },
      countryCode: this.deliveryAddress.country_code,
      transactionSource: 'R', // 'Replacement'
      transactionType: 'W', // Hard coded
      ipAddress: '1.1.1.1', // TODO get IP address?
    } as CardPaymentRedirectRequest;
  }
}
